import { useEffect, useState } from 'react';
import {
 
  Card,
  Button,
  
  Row,
  Col,
  Form,
 
} from "react-bootstrap";
import Swal from "sweetalert2/src/sweetalert2.js";

import Layout from "../../layout/default";
import Block from "../../components/Block/Block";
import {
  Image,
  Icon,
  Media,
 
} from "../../components";
import instance from "../api"

function ProfileSettingsPage() {
  // State for form inputs
  const [passwords, setPasswords] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  });

  const [showPassword, setShowPassword] = useState({
    old: false,
    new: false,
    confirm: false
  });

  const toggleShowPassword = (field) => {
    setShowPassword(prev => ({ ...prev, [field]: !prev[field] }));
  };
  useEffect(() => {
    console.log("Passwords state updated:", passwords);
  }, [passwords]);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setPasswords(prev => ({ ...prev, [name]: value }));
  };
  const token = localStorage.getItem('token');
  const handleSubmit = async (event) => {
    event.preventDefault();
    if (passwords.newPassword !== passwords.confirmPassword) {
      Swal.fire("Error", "New passwords do not match!", "error");
      return;
    }
  
    instance.post('api/Admin/change_password', {
      currentPassword: passwords.currentPassword,
      newPassword: passwords.newPassword,
      confirmPassword: passwords.confirmPassword
    }, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }).then(response => {
      // console.log(response);
      if (response.data.message === "Password changed successfully." && (response.status === 200 || response.status === 201 || response.status === 202)) {
        Swal.fire("Success", "Password updated successfully!", "success");
        setPasswords({ currentPassword: '', newPassword: '', confirmPassword: '' });


              } else {
        Swal.fire("Error", "Failed to update password!", response.error);
      }
    }).catch(error => {
      console.error(error);
      Swal.fire("Error", "Failed to update password!", "error");
    });
  };
  
  

  return (
    <Layout title="My Settings" content="container">
      <Block.Head>
        <Block.HeadBetween className="align-items-start">
          <Block.HeadContent>
            <div className="d-flex flex-column flex-md-row align-items-md-center">
              <Media size="huge" shape="circle">
                <Image
                  src="/images/avatar/profile.png"
                  staticImage
                  thumbnail
                  alt="user"
                />
              </Media>
              <div className="mt-3 mt-md-0 ms-md-3">
                <h3 className="title mb-1">Super Admin</h3>
                <span className="small">Owner & Founder</span>
              </div>
            </div>
          </Block.HeadContent>
        </Block.HeadBetween>
      </Block.Head>
      <Block className="mt-4">
        <Card className="card-gutter-md">
          <Card.Body>
            <Form onSubmit={handleSubmit}>
              <Row className="g-3">
                <Col lg="6">
                  <Form.Group className="form-group">
                    <Form.Label htmlFor="currentPassword">Old Password</Form.Label>
                    <div className="form-control-wrap">
                      <a
                        // href="#password"
                        href="#"
                        // onClick={() => toggleShowPassword('old')}
                        onClick={(e) => {
                          e.preventDefault();
                          toggleShowPassword('old');
                        }}
                        className="form-control-icon end password-toggle"
                        title="Toggle show/hide password"
                      >
                        <Icon name={showPassword.old ? "eye" : "eye-off"} />

                        {/* <Icon name={showPassword.old ? "eye" : "eye-off"} className="on"></Icon>
                        <Icon name={showPassword.old ? "eye-off" : "eye"} className="off"></Icon> */}
                      </a>
                      <Form.Control
                        type={showPassword.old ? "text" : "password"}
                        placeholder="Old password"
                        name="currentPassword"
                        value={passwords.currentPassword}
                        onChange={handleChange}
                      />
                    </div>
                  </Form.Group>
                </Col>
                <Col lg="6">
                  <Form.Group className="form-group">
                    <Form.Label htmlFor="newPassword">New Password</Form.Label>
                    <div className="form-control-wrap">
                      <a
                        href="#"
                        // href="#password"
                        // onClick={() => toggleShowPassword('new')}
                        onClick={(e) => {
                          e.preventDefault();
                          toggleShowPassword('new');
                        }}

                        className="form-control-icon end password-toggle"
                        title="Toggle show/hide password"
                      >
                        <Icon name={showPassword.new ? "eye" : "eye-off"} />

                           {/* <Icon name={showPassword.old ? "eye" : "eye-off"} className="on"></Icon>
                        <Icon name={showPassword.old ? "eye-off" : "eye"} className="off"></Icon> */}
                      </a>
                      <Form.Control
                        type={showPassword.new ? "text" : "password"}
                        placeholder="New password"
                        name="newPassword"
                        value={passwords.newPassword}
                        onChange={handleChange}
                      />
                    </div>
                  </Form.Group>
                </Col>
                <Col lg="6">
                  <Form.Group className="form-group">
                    <Form.Label htmlFor="confirmPassword">Confirm New Password</Form.Label>
                    <div className="form-control-wrap">
                      <a
                        href="#"
                        // href="#password"
                        // onClick={() => toggleShowPassword('confirm')}
                         onClick={(e) => {
                          e.preventDefault();
                          toggleShowPassword('confirm');
                        }}
                        className="form-control-icon end password-toggle"
                        title="Toggle show/hide password"
                      >
                          <Icon name={showPassword.confirm ? "eye" : "eye-off"} />

                            {/* <Icon name={showPassword.old ? "eye" : "eye-off"} className="on"></Icon>
                        <Icon name={showPassword.old ? "eye-off" : "eye"} className="off"></Icon> */}
                      </a>
                      <Form.Control
                        type={showPassword.confirm ? "text" : "password"}
                        placeholder="Confirm New Password"
                        name="confirmPassword"
                        value={passwords.confirmPassword} 
                        onChange={handleChange}
                      />
                    </div>
                  </Form.Group>
                </Col>
              </Row>
              <Button className="mt-3" variant="primary" type="submit">
                Update Password
              </Button>
          
            </Form>
          </Card.Body>
        </Card>
      </Block>
    </Layout>
  );
}

export default ProfileSettingsPage;
